import type { Deal } from '@/models/registry';
import { type DeliveryStage } from '@/models/types.ts';

export function getAllowedDeliveryStages(
  dealStatus: Deal['status'],
): DeliveryStage[] {
  if (dealStatus === 'delivered' || dealStatus === 'done') return ['delivered'];
  if (dealStatus === 'awaiting_delivery')
    return ['pending_pickup', 'in_delivery'];
  return ['none'];
}

export function coerceDeliveryStage(
  dealStatus: Deal['status'],
  currentDeliveryStage?: DeliveryStage,
): DeliveryStage {
  const allowedDeliveryStages = getAllowedDeliveryStages(dealStatus);
  return currentDeliveryStage &&
    allowedDeliveryStages.includes(currentDeliveryStage)
    ? currentDeliveryStage
    : allowedDeliveryStages[0];
}
